import angular from 'angular';
import { IStateParamsService, IStateService } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

///
/// This state selects a report based on its id and then calls up that report component
///

// Register the application's routes configuration.

angular.module('flowingly.runner.report').config(config);

// Inject the dependencies.
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider
    .state('app.runner.report.old', {
      url: 'report/{flowModelId}/{flowModelName}?startDate&endDate',
      redirectTo: STATE_MAPPINGS.report
    })
    .state(STATE_MAPPINGS.report, {
      url: 'report/{flowModelId}?startDate&endDate',
      templateUrl: 'Client/runner.report/runner.report.tmpl.html',
      controller: [
        '$stateParams',
        function ($stateParams: IStateParamsService) {
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const ctrl = this;
          ctrl.flowModelId = $stateParams.flowModelId;
          ctrl.endDate = $stateParams.endDate;
          ctrl.startDate = $stateParams.startDate;
        }
      ],
      controllerAs: 'ctrl'
    });
}
